import { useQuery } from 'react-query';
import { FoodLogResponse, model as foodLogModel } from './foodLog';

export const queryKey = (clientId) => ['client', clientId, 'food-log'];

export const useFoodLog = (clientId) =>
  useQuery<FoodLogResponse>(queryKey(clientId), () => foodLogModel.getList(clientId));
